module.exports = __webpack_public_path__ + "static/header-848088d7c253d9b80fe02a087009b32b.jpg";